import { Badge, Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InputMoney from "../../../components/Forms/Element/InputMoney";
import { useBranch } from "../../../../context/BranchContext";
import BranchSelect from "../../../components/Custom/Main/Branch/BranchSelect";
import { useEffect, useRef, useState } from "react";
import TextArea from "../../../components/Forms/Element/TextArea";
import InputText from "../../../components/Forms/Element/InputText";
import { useLoggedUser } from "../../../../context/LoggedUserContext";
import Clock from "../../../components/Common/Clock";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";
import HintTooltip from "../../../components/Common/HintTooltip";

const Form = (props) => {

    const { t } = useTranslation();
    const { formik } = props;
    const { selectedBranch } = useBranch();
    const [openedBy, setOpenedBy] = useState('');
    const { loggedUser } = useLoggedUser();
    const [currentDateTime, setCurrentDateTime] = useState('');
    const hasInitializedObs = useRef(false);
    const { setFieldValue } = formik;

    // Desablita o campo quando for selecionado uma filial no contexto.
    // Se tiver marcado como todas, habilita e exibe todas as filiais para que o usuário escolha.
    const [disabledBranch, setDisabledBranch] = useState(false);

    useEffect(() => {
        if (selectedBranch === null) {
            setDisabledBranch(false);
            setFieldValue('branch', null);
        } else {
            // Deixa marcado a filial que está no contexto.
            setFieldValue('branch', {
                label: selectedBranch.name,
                value: selectedBranch.id
            });
            setDisabledBranch(true);
        }
    }, [selectedBranch, setFieldValue]);

    useEffect(() => {
        if (loggedUser !== null) {
            setOpenedBy(loggedUser.firstName);

            // O relógio atualiza continuamente. A observação deve ser sugerida uma
            // única vez para não sobrescrever alterações manuais do usuário.
            if (currentDateTime && !hasInitializedObs.current) {
                setFieldValue('obs', t('cash_flow.message.initial_obs', {
                    dateTime: currentDateTime,
                    userName: loggedUser.firstName
                }));
                hasInitializedObs.current = true;
            }
        }
    }, [loggedUser, currentDateTime, setFieldValue, t]);

    const openingStatus = (
        <div className="d-flex flex-column align-items-start align-items-md-end gap-2">
            <Badge bg="success" className="px-3 py-2">
                <i className="fas fa-unlock-alt me-1"></i>
                {t('cash_flow.open')}
            </Badge>
            <div className="text-md-end">
                <small className="text-muted d-block">{t('cash_flow.register_opening_time')}</small>
                <strong className="text-success">
                    <i className="far fa-clock me-1"></i>
                    <Clock setCurrentDateTime={setCurrentDateTime} />
                </strong>
            </div>
        </div>
    );

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('cash_flow.open_cash_register')}
                    description={t('cash_flow.cash_opening_information_hint')}
                    icon="fa-solid fa-cash-register"
                    actions={openingStatus}
                >
                    <Row className="g-3">
                        <Col md={4}>
                            <FormLabel>{t('cash_flow.opened_by')}</FormLabel>
                            <InputText
                                name="openedBy"
                                value={openedBy}
                                disabled={true} />
                        </Col>
                        <Col md={4}>
                            <FormLabel>{t('branch')} <AsteriskRequired/></FormLabel>
                            <BranchSelect
                                name="branch"
                                value={formik.values.branch}
                                onChange={(value) =>
                                    formik.setFieldValue('branch', value)
                                }
                                onBlur={formik.handleBlur}
                                error={formik.errors.branch}
                                isDisabled={disabledBranch} />
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <FormLabel>
                                    {t('cash_flow.opening_balance')} (R$) <AsteriskRequired />
                                    <HintTooltip text={t('cash_flow.opening_balance_hint')} />
                                </FormLabel>
                                <InputMoney
                                    name="openingBalance"
                                    value={formik.values.openingBalance}
                                    // InputMoney devolve o valor normalizado (ponto decimal), como no lançamento de movimentações.
                                    onChange={(value) => formik.setFieldValue('openingBalance', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.openingBalance}
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '1.05rem'
                                    }} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    compact
                    title={t('obs')}
                    description={t('cash_flow.cash_opening_notes_hint')}
                    icon="fa-solid fa-note-sticky"
                >
                    <Row>
                        <Col md={12}>
                            <TextArea name="obs" style={{ height: "100px" }}
                                maxLength={80}
                                value={formik.values.obs}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                counter="true"
                                placeholder={t('cash_flow.opening_obs_placeholder')}
                            />
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
